import {useEffect, useState} from 'react'

import {KTSVG} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {ROLE_ROOT} from '../../../../app/common/Utils'
import {MultiSelect} from '../../../common/components/MultiSelect'
import {MultiSelectOption,MultiSelectGroupOptions} from '../../../common/models/MultiSelectOption'

const SelectClientDrawer = () => {
  const intl = useIntl()
  const {auth, changeClientKey} = useAuth()
  const [allOptions, setAllOptions] = useState<MultiSelectOption[]>([])
  const [allGroupOptions, setAllGroupOptions] = useState<MultiSelectOption[]>([])
  const [selectedGroup, setSelectedGroup] = useState<MultiSelectGroupOptions | null>(null)
  const [groupClientsMap, setGroupClientsMap] =useState<Record<string, { label: string; value: string }[]>>({})
  const [filteredClients, setFilteredClients] = useState<MultiSelectOption[]>([])
  const [selectedKey, setSelectedKey] = useState<MultiSelectOption | null>(null)
  const {currentUser} = useAuth()

  useEffect(() => {
    if (selectedKey !== null) {
      changeClientKey(selectedKey.value, selectedKey.label)
    } else {
      if (auth && auth.clientAccess && auth.clientAccess.length > 0) {
        const client = auth.clientAccess.find((item) => item.clientKey === auth.clientKey)
        changeClientKey(client?.clientKey!, client?.name!)
      }
    }
  }, [selectedKey])

  useEffect(() => {
  if (auth && auth.clientGroupAccess && auth.clientGroupAccess.length > 0) {
    const items = auth.clientAccess.map(x => ({
      label: x.name,
      value: x.clientKey,
    }))
    setAllOptions(items)
  } else {
    setAllOptions([])
  }
}, [auth])


  useEffect(() => {
  if (auth && auth.clientGroupAccess && auth.clientGroupAccess.length > 0) {

    const groups = auth.clientGroupAccess.map(g => ({
      label: g.name,
      value: g.name, 
    }))
    setAllGroupOptions(groups)
    const map : Record<string, { label: string; value: string }[]> = {}
    auth.clientGroupAccess.forEach(g => {
      map[g.name] = g.clientAccess.map(c => ({
        label: c.name,
        value: c.clientKey,
      }))
    })
    setGroupClientsMap(map)

  } else {
    setAllGroupOptions([])
    setGroupClientsMap({})
  }
}, [auth])

  useEffect(() => {
  if (!selectedGroup) {
    setFilteredClients(allOptions)
    return
  }

  const clients = groupClientsMap[selectedGroup.label]

  if (clients) {
    setFilteredClients(clients)
  } else {
    setFilteredClients(allOptions)
  }
}, [selectedGroup, allOptions, groupClientsMap])



  return (
  <div
    id='kt_access'
    className='bg-white'
    data-kt-drawer='true'
    data-kt-drawer-name='access'
    data-kt-drawer-activate='true'
    data-kt-drawer-overlay='true'
    data-kt-drawer-width="{default:'300px', 'lg': '600px'}"
    data-kt-drawer-direction='end'
    data-kt-drawer-toggle='#kt_access_toggle'
    data-kt-drawer-close='#kt_access_close'
  >
    <div className='card shadow-none w-100 rounded-0'>

      <div className='card-header d-flex justify-content-between align-items-center'>
        <h3 className='card-title fw-bolder text-dark'>Select Client</h3>

        <button
          type='button'
          className='btn btn-sm btn-icon btn-active-light-primary'
          id='kt_access_close'
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr061.svg'
            className='svg-icon-1'
          />
        </button>
      </div>

      <div className='card-body d-flex flex-column gap-5'>

        {currentUser?.role === ROLE_ROOT && (
          <div>
            <label className='form-label'>
              {intl.formatMessage({id: 'FORM.CLIENT_GROUP'})}
            </label>

            <MultiSelect
              setSelectedOption={setSelectedGroup}
              options={allGroupOptions}
              isMulti={false}
            />
          </div>
        )}
        <div>
          <label className='form-label'>
            {intl.formatMessage({id: 'FORM.CLIENT'})}
          </label>

          <MultiSelect
            setSelectedOption={setSelectedKey}
            options={filteredClients}
            isMulti={false}
          />
        </div>

      </div>
    </div>
  </div>
)

}
export {SelectClientDrawer}
